module.exports = __webpack_public_path__ + "static/media/womenIntern.56a6d5e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/womenIntern.jpg
// module id = 403
// module chunks = 0